<script>
    export let activeDays = []
    export let editable = false

    const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]

    function switchDay(weekDay) {
        if (activeDays.includes(weekDay)) {
            activeDays = activeDays.filter(e => e !== weekDay)
        } else {
            activeDays = [...activeDays, weekDay]
        }
    }

</script>

<ul>
    {#each weekDays as weekDay}
        {#if editable}
            <li>
                <button class="{activeDays.includes(weekDay) ? 'active' : 'inactive'} btn" on:click="{() => switchDay(weekDay)}">
                    {weekDay}
                </button>
            </li>
	    {:else}
            <li class="{activeDays.includes(weekDay) ? 'active' : 'inactive'}">{weekDay}</li>
	    {/if}
    {/each}
</ul>

<style>
    .active {
        background-color: #26A69A;
        color: white;
    }
    .inactive {
        background-color: #EEEEEE;
        color: #9E9E9E;
    }
    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    li {
        float: left;
        padding: 5px;
    }
</style>